import { GetIdeasResponse } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

export const useIdeas = (tripId: string | undefined) => {
	return useQuery<GetIdeasResponse>({
		queryKey: queryKeys.ideas(tripId),
		queryFn: async () => {
			const { data } = await api.get<GetIdeasResponse>(`/ideas?tripId=${tripId}`)
			return data
		},
		enabled: !!tripId,
	})
}
